import * as React from 'react';
import { I18nextProvider } from 'react-i18next';
import { useI18next, I18nextContext, I18nContext } from 'gatsby-plugin-react-i18next';
import i18n from './i18n';

export const wrapPageElement = ({ element, props }) => {
    const { pageContext } = props;

    i18n.changeLanguage(pageContext.language);

    return (
        <I18nextContext.Provider value={pageContext}>
            <I18nextProvider i18n={i18n}>{element}</I18nextProvider>
        </I18nextContext.Provider>
    );
};
